/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_IndigoInputs */

const en_booking_color_indigo = /** @type {(inputs: Booking_Color_IndigoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indigo`)
};

const pl_booking_color_indigo = /** @type {(inputs: Booking_Color_IndigoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indygo`)
};

/**
* | output |
* | --- |
* | "Indigo" |
*
* @param {Booking_Color_IndigoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_indigo = /** @type {((inputs?: Booking_Color_IndigoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_IndigoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_indigo(inputs)
	return en_booking_color_indigo(inputs)
});